import React from "react"
import "./PrivacyPolicy.css"

function PrivacyPolicy() {
  return (
    <div className="PrivacyPolicy">
      <h1>GENERAL DATA PRIVACY POLICY</h1>
      <p className="as-of">(as of 06 December 2017)</p>
      <ol className="main-list">
        <li>
          <h2>Overview</h2>

          <p>
            We, [insert name of company[, (‘the Company’) provide [general
            description of business/services] to our clients. In providing such
            support and services, we rely heavily on personal information,
            whether it be the information of our clients, our employees, or any
            other individual in connection with any matter that we handle.
          </p>
          <p>
            Given the importance of privacy to all concerned parties, we are
            committed to the highest standards of privacy and data protection
            compliance and expect everyone in our Company to adhere to these
            standards. We demand highest standards of ethics and compliance with
            applicable laws and rules from our management, employees, and third
            party suppliers and service providers.
          </p>
          <p>
            This Privacy Policy will help you understand: (i) what Personal
            Information we collect; (ii) how we collect, hold, use and disclose
            that information; and (iii) the purposes of such collection,
            holding, use and disclosure.
          </p>
        </li>
        <li>
          <h2>To what does this Privacy Policy apply?</h2>
          <p>
            This Policy applies to all of our facilities, as well as all the
            services that we offer.
          </p>
          <p>
            This Policy does not apply to any website, product or service of any
            third-party organization even if the website links to (or from) our
            Website. Please always review the privacy practices of any
            third-party organization before deciding whether to provide any
            information.
          </p>
          <p>
            By using our services, you accept the practices described in this
            Policy. If you do not agree with this Policy, you should immediately
            cease and desist from using our Services. Continued use of our
            Services will signify your acceptance of this Policy.
          </p>
        </li>
        <li>
          <h2>What information do we collect?</h2>
          <p>
            When you use our Services, we collect your Personal Information.
          </p>
          <p>
            The term “Personal Information”, as used in this Policy, refers to
            any data (whether by itself or when linked with other information)
            in the possession of, or likely to come into the possession of the
            Company, that can be used to identify a specific living person.
          </p>
          <p>
            Personal Information does not include information that has been
            aggregated or made anonymous such that it can no longer be
            reasonably associated with a specific person.
          </p>
        </li>
        <li>
          <h2>Why do we collect your Personal Information?</h2>
          <p>
            We collect your Personal Information for the following purposes:
          </p>
          <ul>
            <li>To [insert purpose specific to the Company];</li>
            <li>To [insert purpose specific to the Company];</li>
            <li>To [insert purpose specific to the Company];</li>
            <li>To maintain constant communication with our clients;</li>
            <li>
              To manage the process of billing our clients for services
              rendered; and
            </li>
            <li>
              To assert and defend any legal claims by or against the Company.
            </li>
          </ul>
          <p>
            Subject to the Data Privacy Act and with your consent, we may share,
            preserve, transfer, and disclose your Personal Information to the
            following:
          </p>
          <ul>
            <li>
              Third party suppliers and service providers that help us provide
              our services, to the extent needed to perform their duties and
              their functions; and
            </li>
            <li>
              Government authorities and such entities that may have a
              legitimate and legal interest in the information, in response to a
              legal request such as a search warrant, court order or subpoena,
              if we believe in good faith that we are required to do so under
              the law.
            </li>
          </ul>
        </li>
        <li>
          <h2>How do we collect your information?</h2>

          <p>
            Whenever you use our Services, we collect your Personal Information.{" "}
          </p>
          <p>
            Broadly speaking, we collect information in three ways: (1) when you
            provide it directly to us, (2) when we obtain verification
            information about you or your company through trusted third parties,
            and (3) passively through technology such as “cookies”.
          </p>
          <p>
            Specifically, we collect Personal Information from you through
            contracts, notes taken and prepared by our lawyers and staff,
            physical or electronic communication (e.g. electronic mail),
            verification information from trusted third parties, passive
            technologies (e.g. cookies), and documents or forms bearing your
            personal information that you submitted or was acquired by us with
            your authorization.
          </p>
        </li>
        <li>
          <h2>
            What are your rights as a data subject and how do you exercise them?
          </h2>
          <p>
            As a data subject whose Personal Information will be collected and
            processed by us, you are entitled to the following rights, pursuant
            to Section 16 of Republic Act No. 10173, otherwise known as the Data
            Privacy Act of 2012, and Section 34 of its Implementing Rules and
            Regulations:
          </p>
          <ol>
            <li>
              <h3>Right to be informed</h3>
              <p>
                You have a right to be informed whether Personal Information
                pertaining to you shall be, are being, or have been processed,
                including the existence of automated decision-making and
                profiling.
              </p>
            </li>
            <li>
              <h3>Right to object</h3>
              <p>
                You shall have the right to object to the processing of your
                Personal Information, including processing for direct marketing,
                automated processing or profiling. You shall also be notified
                and be given an opportunity to withhold consent to the
                processing in case of changes or any amendment to the
                information supplied or declared to the data subject.
              </p>
            </li>
            <li>
              <h3>Right to Access</h3>
              <p>
                You have a right to be given access to specific kinds of
                information identified in the Data Privacy Act upon reasonable
                demand.
              </p>
            </li>
            <li>
              <h3>Right to Rectification</h3>
              <p>
                The data subject has the right to dispute the inaccuracy or
                error in the Personal Information and have us correct it
                immediately and accordingly, unless the request is vexatious or
                otherwise unreasonable.
              </p>
            </li>
            <li>
              <h3>Right to Erasure or Blocking</h3>
              <p>
                You shall have the right to suspend, withdraw or order the
                blocking, removal or destruction of your Personal Information
                from our filing system.
              </p>
            </li>
            <li>
              <h3>Right to Damages</h3>
              <p>
                Upon presentation of a valid decision, we recognize your right
                to be indemnified for any damages sustained due to inaccurate,
                incomplete, outdated, false, unlawfully obtained or unauthorized
                use of Personal Information, taking into account any violation
                of your rights and freedoms as data subject.
              </p>
              <p>
                Please note that this is not an exhaustive discussion of your
                rights as a data subject. If you wish to know more, please see
                our Data Subject Rights Policy.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2>
            What the principles do we follow when we collect your information?
            (Optional)
          </h2>
          <p>
            In compliance with the applicable laws and regulations, we pledge to
            observe the following principles:
          </p>
          <ol>
            <li>
              <h3>Principle of Transparency</h3>

              <p>
                We are committed to ensuring that you know why we collect
                Personal Information, as well as how much of it we collect. As
                we seek to ensure the security of your Personal Information, we
                make sure that you know what risks are involved when we collect
                and use your Personal Information, as well as the measures we
                have established to ensure that those risks are lessened or
                eliminated.
              </p>
            </li>
            <li>
              <h3>Principle of Legitimate Purpose</h3>

              <p>
                We are committed to ensuring that your Personal Information will
                only be used for specified, legitimate purposes. No Personal
                Information shall be used for a purpose other than that which
                has been told to you and have been consented to by them.
              </p>
              <p>
                No Personal Information shall be collected without your consent.
                If you wish to withdraw consent to the collection of your
                Personal Information, kindly give us reasonable notice so we may
                have time to cease any and all processing
              </p>
            </li>
            <li>
              <h3>Principle of Proportionality</h3>
              <p>
                We are committed to ensuring that we do not collect Personal
                Information more than what is necessary from you. Personal
                Information shall be collected only to the extent that is needed
                for the purposes specified in this Policy.
              </p>
            </li>
            <li>
              <h3>Principle of Lawful Processing</h3>
              <p>
                We pledge that we shall uphold your right as a Data Subject. You
                shall have the right to refuse, withdraw, consent, or object to
                the use and collection of your Personal Information.
              </p>
              <p>
                In the event that you refuse to give consent, your Personal
                Information shall no longer be processed, unless:
              </p>
              <ul>
                <li>
                  The Personal Information is needed pursuant to a subpoena;
                </li>
                <li>
                  The collection and processing are for obvious purposes,
                  including, when it is necessary for the performance of or in
                  relation to a contract or service to which the customer is a
                  party; or
                </li>
                <li>
                  The information is being collected and processed as a result
                  of a legal obligation.
                </li>
              </ul>
              <p>
                Any information to be provided by you shall always be in clear
                and plain language, to ensure that the information is easy to
                understand and access.
              </p>
            </li>
            <li>
              <h3>Data Retention</h3>
              <p>
                Whatever Personal Information given to us by you or pertaining
                to you shall only be retained for as long as necessary:
              </p>
              <ul>
                <li>
                  For the fulfillment of the declared, specified, and legitimate
                  purpose, or when the processing relevant to the purpose has
                  been terminated;
                </li>
                <li>
                  For the establishment, exercise, or defense of legal claims;
                  or
                </li>
                <li>
                  For legitimate business purposes, which must be consistent
                  with standards followed by the applicable industry or approved
                  by the appropriate government agency.
                </li>
              </ul>
              <p>
                Personal Information provided to us by you shall be disposed or
                discarded in a secure manner that would prevent further
                processing, unauthorized access, or disclosure to any other
                party, or prejudice the interests of our customers.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h2>Why do we retain your personal information?</h2>
          <p>
            We will retain Personal Information for the period necessary to
            fulfill the purposes outlined in this Privacy Policy unless a longer
            retention period is required or permitted by the Data Privacy Act of
            2012. Please note that we have a variety of obligations to retain
            the Data that you provide to us, including to ensure that
            transactions can be appropriately processed, settled, refunded or
            charged-back, to help identify fraud and to comply with anti-money
            laundering and other laws and rules that apply to us and to our
            financial service providers. There may also be residual Data that
            will remain within our databases and other records, which will not
            be removed.
          </p>
          <h2>How do we protect your personal information?</h2>
          <p>
            We use reasonable organizational, technical and administrative
            measures to protect Personal Information within our organization.
            [Insert additional discussion here relating to the Company’s data
            privacy framework. E.g., DPO, training program for staff, physical
            security measures, etc.]
          </p>
          <p>
            Unfortunately, no data transmission or storage system can be
            guaranteed to be 100% secure. If the customer has reason to believe
            that his interaction with us is no longer secure (for example, if
            the customer feels that the security of his account has been
            compromised), please contact our Data Protection Officer
            immediately. His contact details are provided in Part XI below.
          </p>
        </li>
        <li>
          <h2>What about changes to this policy?</h2>
          <p>
            We may change this Privacy Policy. The “Last updated” legend at the
            top of this Privacy Policy indicates when this Privacy Policy was
            last revised. Any changes are effective when we post the revised
            Privacy Policy on the Services.
          </p>
          <p>
            We may provide you with disclosures and alerts regarding the Privacy
            Policy or Personal Information collected by posting them on our
            website. By using our Services, you agree that electronic
            disclosures and notices have the same meaning and effect as if we
            had provided you with hard copy disclosures. Disclosures and notices
            in relation to this Privacy Policy or Personal Information shall be
            considered to be received by you within twenty-four (24) hours of
            the time they are posted to our website.
          </p>
        </li>
        <li>
          <h2>How can you reach us?</h2>
          <p>
            If you have any questions or suggestions about this Privacy Policy
            or would like to access or seek correction of your Personal
            Information, or if you have any complaints regarding our privacy
            practices, please contact our Data Protection Officer. His contact
            information is as follows:
          </p>
          <p>
            Name: <br />
            Office Address: <br />
            Contact Number: <br />
            Email Address:
            <br />
          </p>

          <p>
            Please note that you, as the requesting party, would have to pay the
            reasonable costs and expenses incurred by the Company for producing
            the requested information.
          </p>
          <p>
            Because email communications are not always secure, you are asked to
            not include credit card or other sensitive data (such as racial or
            ethnic origin, political opinions, religion, health, or the like) in
            emails sent to us.
          </p>
        </li>
      </ol>
    </div>
  )
}

export default PrivacyPolicy
